var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list"},_vm._l((_vm.applesInTree),function(apple){return _c('li',{key:apple.name,staticClass:"apple",class:apple.falling === true ? 'apple-fall' : '',style:(apple.style)})}))])}
var staticRenderFns = []

export { render, staticRenderFns }